import React, { useEffect, useState } from 'react';
import { redirect } from '../lib/Utils';
import { useTranslation } from 'react-i18next';
import { Typography, LinearProgress } from '@mui/material';
import useService from '../hooks/useService';
import userInfo from '../lib/services/userInfo';
import { ErrorCodes, ResponseErrorBodyDataNotSignedAgreement } from '../types';
import AgreementsApprove from '../components/AgreementsApprove';
import UPPage from '../components/UPPage';

/**
 * Success Page. After Login.
 */
export default function() {
  const [resend, setResend] = useState(0);
  const { send, isRequestDone, response } = useService(userInfo);
  const { t } = useTranslation();

  useEffect(() => {
    send();
  }, [send, resend]);

  useEffect(() => {
    if (
      isRequestDone &&
      response &&
      response.error &&
      response.error.code !== ErrorCodes.NOT_SIGNED_AGREEMENT
    ) {
      redirect('/auth');
    }
  });
  if (
    !isRequestDone ||
    (response &&
      response.error &&
      response.error.code !== ErrorCodes.NOT_SIGNED_AGREEMENT)
  ) {
    return <LinearProgress color="primary" />;
  }

  let content;
  if (
    response &&
    response.error &&
    response.error.code === ErrorCodes.NOT_SIGNED_AGREEMENT
  ) {
    content = (
      <AgreementsApprove
        agreementsUnsigned={
          (response.error.data as ResponseErrorBodyDataNotSignedAgreement)
            .agreements
        }
        onSuccess={() => setResend(resend => resend + 1)}
      />
    );
  } else {
    content = <Typography variant="body1">{t('authSuccess')}</Typography>;
  }

  return <UPPage>{content}</UPPage>;
}
